import { FC } from 'react'

/**
 * * Icon Component for: hourglass-01, hourglass-02, hourglass-03
 */
type HourGlassOutlineIconProps = {
  variant: 1 | 2 | 3 | 4
  size?: number
  color?: string
}
export const HourGlassOutlineIcon: FC<HourGlassOutlineIconProps> = ({
  variant,
  size = '1rem',
  color = 'currentColor',
  ...rest
}) => {
  const iconAttributes = {
    width: size,
    height: size,
    stroke: color,
  }

  switch (variant) {
    case 1:
      return (
        <svg viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest} {...iconAttributes}>
          <path
            d="M2.02128 19H11.9787C12.5428 19 13 18.5395 13 17.9714V15.2237C13 15.0042 12.9302 14.7904 12.8009 14.6136L9.85578 10.5881C9.59813 10.2359 9.58984 9.75815 9.8351 9.39712L12.5663 5.3769C12.6825 5.20582 12.7447 5.00337 12.7447 4.79608V2.02857C12.7447 1.46051 12.2874 1 11.7234 1H2.02128C1.45724 1 1 1.46051 1 2.02857V4.77626C1 4.99584 1.06977 5.20964 1.19909 5.38641L4.12807 9.38985C4.39353 9.75269 4.39353 10.2473 4.12807 10.6101L1.19909 14.6136C1.06977 14.7904 1 15.0042 1 15.2237V17.9714C1 18.5395 1.45724 19 2.02128 19Z"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )

    case 2:
      return (
        <svg viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest} {...iconAttributes}>
          <path
            d="M4.57447 15.9143H9.42553M11.9787 19H2.02128C1.45724 19 1 18.5395 1 17.9714V15.2237C1 15.0042 1.06977 14.7904 1.19909 14.6136L4.12807 10.6101C4.39353 10.2473 4.39353 9.75269 4.12807 9.38985L1.19909 5.38641C1.06977 5.20964 1 4.99584 1 4.77626V2.02857C1 1.46051 1.45724 1 2.02128 1H11.7234C12.2874 1 12.7447 1.46051 12.7447 2.02857V4.79608C12.7447 5.00337 12.6825 5.20582 12.5663 5.3769L9.8351 9.39712C9.58984 9.75815 9.59813 10.2359 9.85578 10.5881L12.8009 14.6136C12.9302 14.7904 13 15.0042 13 15.2237V17.9714C13 18.5395 12.5428 19 11.9787 19Z"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )

    case 3:
      return (
        <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest} {...iconAttributes}>
          <path
            d="M6 3H20M6 21H20M18.25 3V5.64723C18.25 6.33742 18.012 7.0065 17.5762 7.54167L14.7011 11.072C14.1922 11.6969 14.2043 12.5794 14.7301 13.1912L17.525 16.4423C17.9928 16.9865 18.25 17.6803 18.25 18.3979V21M7.75 3V5.64723C7.75 6.33742 7.98798 7.0065 8.42383 7.54167L11.2989 11.072C11.8078 11.6969 11.7957 12.5794 11.2699 13.1912L8.47505 16.4423C8.00724 16.9865 7.75 17.6803 7.75 18.3979V21"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )

    case 4:
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M6.58646 16.6663H13.4135V14.1663C13.4135 13.2176 13.0818 12.4061 12.4183 11.732C11.7549 11.0578 10.9488 10.7207 10 10.7207C9.05125 10.7207 8.24514 11.0581 7.58167 11.733C6.91819 12.4077 6.58646 13.2188 6.58646 14.1663V16.6663ZM10 9.27863C10.9488 9.27863 11.7549 8.9412 12.4183 8.26634C13.0818 7.59162 13.4135 6.78051 13.4135 5.83301V3.33301H6.58646V5.83301C6.58646 6.78176 6.91819 7.59322 7.58167 8.26738C8.24514 8.94155 9.05125 9.27863 10 9.27863ZM4.375 17.9163C4.19792 17.9163 4.04951 17.8564 3.92979 17.7365C3.80993 17.6167 3.75 17.4682 3.75 17.2911C3.75 17.1139 3.80993 16.9655 3.92979 16.8459C4.04951 16.7262 4.19792 16.6663 4.375 16.6663H5.33667V14.1663C5.33667 13.2283 5.59333 12.3744 6.10667 11.6047C6.62 10.8348 7.30028 10.2998 8.1475 9.99967C7.30028 9.69412 6.62 9.1578 6.10667 8.39072C5.59333 7.62363 5.33667 6.77106 5.33667 5.83301V3.33301H4.375C4.19792 3.33301 4.04951 3.27308 3.92979 3.15322C3.80993 3.03335 3.75 2.88488 3.75 2.7078C3.75 2.53058 3.80993 2.38217 3.92979 2.26259C4.04951 2.14287 4.19792 2.08301 4.375 2.08301H15.625C15.8021 2.08301 15.9505 2.14294 16.0702 2.2628C16.1901 2.38266 16.25 2.53113 16.25 2.70822C16.25 2.88544 16.1901 3.03384 16.0702 3.15342C15.9505 3.27315 15.8021 3.33301 15.625 3.33301H14.6633V5.83301C14.6633 6.77106 14.4067 7.62363 13.8933 8.39072C13.38 9.1578 12.6997 9.69412 11.8525 9.99967C12.6997 10.2998 13.38 10.8348 13.8933 11.6047C14.4067 12.3744 14.6633 13.2283 14.6633 14.1663V16.6663H15.625C15.8021 16.6663 15.9505 16.7263 16.0702 16.8461C16.1901 16.966 16.25 17.1145 16.25 17.2915C16.25 17.4688 16.1901 17.6172 16.0702 17.7368C15.9505 17.8565 15.8021 17.9163 15.625 17.9163H4.375Z"
            fill="#6B6A76"
          />
        </svg>
      )
  }
}
